import { render, staticRenderFns } from "./DropdownButton.vue?vue&type=template&id=210f3a83&scoped=true&lang=pug&"
import script from "./DropdownButton.vue?vue&type=script&lang=js&"
export * from "./DropdownButton.vue?vue&type=script&lang=js&"
import style0 from "./DropdownButton.vue?vue&type=style&index=0&id=210f3a83&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210f3a83",
  null
  
)

export default component.exports